import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useEffect, useState} from "react";
import {ZoneDetailFatherAndChild} from "../../../../reduxToolkit/EmployeeZones/EmployeeZonesApi";
import {DeleteItemsApi} from "../../../../reduxToolkit/Commons/CommonsApi";
import {useParams} from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import routes from "../../../../Routes/routes";
import {errorMsg} from "../../../../Apis/functions";
import {TABLES} from "../../../../Apis/Tables";
import {IconChevronRight} from "../../../../components/buttons/IconButtons";

/**
 * SingleZoneDetailsApp Hook
 * @Email: azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @JobTitle: Full Stack Developer
 * Custom hook to manage the state and actions for the Single Zone Details view. It handles translation,
 * dispatching Redux actions, local state management (e.g., modal visibility, pagination, selection for deletion),
 * and session storage for maintaining the zones stack.
 *
 * @function SingleZoneDetailsApp
 * @returns {Object} An object containing various state variables, setters, and functions including:
 */

export const SingleZoneDetailsApp = () => {
    const {t} = useTranslation();
    const {id} = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const {permission} = useSelector((state) => state.authenticatioauthennSlice);
    const [modalShow, setModalShow] = useState(false);
    const [isFatherZone, setIsFatherZone] = useState({});
    const [isAllCheckedSubZone, setIsAllCheckedSubZone] = useState(false);
    const [selectSubZoneForDelete, setSelectSubZoneForDelete] = useState([]);
    const [deleteShowSubZone, setDeleteShowSubZone] = useState(false);
    const [stack, setStack] = useState(JSON.parse(sessionStorage.getItem('zonesStack')) || []);
    const [inputValue, setInputValue] = useState({id: '', name: ''});
    const [backResponse, setBackResponse] = useState(false);
    const [modified, setModified] = useState(false);
    const { zoneDetailFatherAndChild} = useSelector((state) => state.EmployeeZonesSlice);
    // set lng and lng for current zone
    sessionStorage.setItem('currentZoneLat', zoneDetailFatherAndChild?.latitud);
    sessionStorage.setItem('currentZoneLng', zoneDetailFatherAndChild?.longitud);

    // Fetch data whenever pagination or modification changes
    useEffect(() => {
        getData();
    }, [id]);
    // Fetch data if there are any changes in modifications

    useEffect(() => {
        if (modified) {
            getData();
            setModified(false);
        }
    }, [modified]);

    // Function to get zone father and child details data with pagination
    const getData = () => {
        dispatch(ZoneDetailFatherAndChild({zoneId: id})).then(({payload: {data: {data,success}}}) => {
                if (success === true) {
                    if (data?.id) {
                        let aux = [...stack];
                        aux = aux.map(e => {
                            if(e.id === data.id) e.name = data.name;
                            return e;
                        })
                        setStack(aux);
                        sessionStorage.setItem('zonesStack', JSON.stringify(aux));
                        setInputValue({id: data?.id, name: data?.name});
                    }
                }
            },
        );
    }

    // api function
    const deleteSubZone = (deleteItem) => {
        const body = deleteItem;
        dispatch(DeleteItemsApi({tableName: TABLES.ZONE, body})).then(({payload: {data: { success, code },},}) => {
                if(success){
                    setModified(true);
                    setSelectSubZoneForDelete([]);
                }else errorMsg(code)
            },
        );
    };

    const isDuplicateId = (newId) => {
        return stack.some((obj) => obj.id === newId);
    };

    const pushToStack = () => {
        if (
            inputValue.id !== '' &&
            inputValue.name !== '' &&
            inputValue.id !== null &&
            inputValue.name !== null &&
            inputValue.id !== undefined &&
            inputValue.name !== undefined
        ) {
            if (!isDuplicateId(inputValue.id) && inputValue !== '' && inputValue !== undefined && inputValue !== null) {
                setStack([...stack, inputValue]);
                setInputValue({id: '', name: ''})
            }
        }
    };
    const popFromStack = () => {
        if (stack.length > 0) {
            const newStack = [...stack];
            newStack.pop();
            setStack(newStack);
        }
    };

    useEffect(() => {
        if (inputValue.name !== '') {
            pushToStack();
        }
    }, [inputValue]);

    useEffect(() => {
        if (backResponse) {
            const newZoneId = stack[stack.length - 2]?.id;
            if (newZoneId) {
                dispatch(ZoneDetailFatherAndChild({zoneId: newZoneId})).then(({payload: {data:{success}}}) => {
                    if (success){
                        popFromStack();
                        navigate(routes.zone.details + newZoneId);
                        setBackResponse(false);
                    }
                });
            }
        }
    }, [backResponse]);

    useEffect(() => {
        if (stack.length > 0) {
            sessionStorage.setItem('zonesStack', JSON.stringify(stack));
        }
    }, [stack]);

    const renderZoneStack = () => {
        const maxVisible = 3;
        const itemsToRender = [];

        if (stack.length <= maxVisible * 2) {
            stack.forEach((item, index) => itemsToRender.push({ item, index }));
        } else {
            for (let i = 0; i < maxVisible; i++) {
                itemsToRender.push({ item: stack[i], index: i });
            }
            itemsToRender.push({ isEllipsis: true });
            for (let i = stack.length - maxVisible; i < stack.length; i++) {
                itemsToRender.push({ item: stack[i], index: i });
            }
        }

        return itemsToRender.map((entry, i) => {
            if (entry.isEllipsis) {
                return (
                    <div key="ellipsis">
                        <IconChevronRight/>
                        <span className="mx-2 font-color-general-950 fs-14px">...</span>
                    </div>
                );
            }

            const { item, index } = entry;
            const isLast = index === stack.length - 1;

            return (
                <div key={index} className="flex items-center inline-flex">
                    {index > 0 && (
                        <IconChevronRight/>
                    )}
                    <span
                        className={
                            isLast
                                ? 'ml-3 father-child-zone-selected'
                                : 'mx-3 father-child-zone'
                        }
                        onClick={() => {
                            if (!isLast) {
                                dispatch(ZoneDetailFatherAndChild({ zoneId: item?.id })).then(
                                    ({ payload: { data: { success, code } } }) => {
                                        if (success) {
                                            setInputValue({ id: '', name: '' });
                                            setStack(stack.slice(0, index + 1));
                                            navigate(`${routes.zone.details}${item?.id}`);
                                            setModified(true);
                                        } else errorMsg(code);
                                    }
                                );
                            }
                        }}
                    >
                    {item.name}
                </span>
                </div>
            );
        });
    };


    return {
        t,
        setBackResponse,
        DEV,
        permission,
        zoneDetailFatherAndChild,
        setModalShow,
        setIsFatherZone,
        selectSubZoneForDelete,
        setDeleteShowSubZone,
        stack,
        modalShow,
        isFatherZone,
        deleteShowSubZone,
        deleteSubZone,
        setSelectSubZoneForDelete,
        setIsAllCheckedSubZone,
        isAllCheckedSubZone,
        modified,
        setModified,
        renderZoneStack
    }
}
